import { SPRest } from "../rest.js";
import { HubSites } from "./types.js";
import "./site.js";
import "./web.js";
export { HubSite, HubSites, } from "./types.js";
Reflect.defineProperty(SPRest.prototype, "hubSites", {
    configurable: true,
    enumerable: true,
    get: function () {
        return this.childConfigHook(function (_a) {
            var options = _a.options, baseUrl = _a.baseUrl, runtime = _a.runtime;
            return HubSites(baseUrl).configure(options).setRuntime(runtime);
        });
    },
});
//# sourceMappingURL=index.js.map